import { useTheme } from '@/hooks/useTheme';
import { Button } from '@/components/ui/button';
import {
  SunIcon,
  MoonIcon,
  ComputerDesktopIcon,
} from '@heroicons/react/24/outline';
import { cn } from '@/lib/utils';

type ThemeToggleVariant = 'icon' | 'full';

interface ThemeToggleProps {
  variant?: ThemeToggleVariant;
  className?: string;
}

const THEME_LABELS: Record<'light' | 'dark' | 'system', string> = {
  light: 'Tema claro',
  dark: 'Tema oscuro',
  system: 'Según sistema',
};

export function ThemeToggle({ variant = 'icon', className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  const icon =
    theme === 'system' ? (
      <ComputerDesktopIcon className="h-5 w-5" aria-hidden />
    ) : theme === 'dark' ? (
      <MoonIcon className="h-5 w-5" aria-hidden />
    ) : (
      <SunIcon className="h-5 w-5" aria-hidden />
    );

  const label = THEME_LABELS[theme];

  return (
    <Button
      type="button"
      variant="ghost"
      size={variant === 'icon' ? 'icon' : 'sm'}
      onClick={toggleTheme}
      className={cn(
        variant === 'icon' && 'min-h-[44px] min-w-[44px]',
        className
      )}
      aria-label={label}
      title={label}
    >
      {icon}
      {variant === 'full' && (
        <span className="sr-only sm:not-sr-only sm:ml-0 sm:inline">
          {label}
        </span>
      )}
    </Button>
  );
}
